import React from 'react';
import { Box, Typography, Switch } from '@mui/material';

/** Section with title on the left and enable switch on the right. Children shown only when enabled. */
export default function StepSection({ title, enabled, onEnabledChange, children }) {
  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
        <Typography variant="subtitle2" fontWeight={600}>
          {title}
        </Typography>
        <Switch checked={enabled} onChange={(e) => onEnabledChange(e.target.checked)} size="small" />
      </Box>
      {enabled && children}
    </>
  );
}
